import React from "react";
import { Button, Container } from "react-bootstrap";
import styles from "./serviceItem.module.css";
import data from "../data";
import { Link, useParams } from "react-router-dom";

function ServiceItem() {
  const params = useParams();
  return (
    <div className={styles.service__item}>
      <Container>
        {data
          .filter((el) => el.id === params.id)
          .map((el) => (
            <div className={styles.sercive__content}>
              <div className={styles.service__text}>
                <h3>{el.name}</h3>
                <p>{el.desc}</p>
                <Link to="/">
                  <Button>العودة الي الرئسية</Button>
                </Link>
              </div>
              <div className={styles.service__img}>
                <img src={el.image} />
              </div>
            </div>
          ))}
      </Container>
    </div>
  );
}

export default ServiceItem;
